import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import FormationB2C from "@/pages/FormationB2C";
import FormationB2B from "@/pages/FormationB2B";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueCookies from "@/pages/PolitiqueCookies";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.FORMATION_B2C} element={<FormationB2C />} />
          <Route path={ROUTE_PATHS.FORMATION_B2B} element={<FormationB2B />} />
          <Route path={ROUTE_PATHS.CONFIDENTIALITE} element={<PolitiqueConfidentialite />} />
          <Route path={ROUTE_PATHS.MENTIONS_LEGALES} element={<MentionsLegales />} />
          <Route path={ROUTE_PATHS.COOKIES} element={<PolitiqueCookies />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;